export default "__VITE_ASSET__Cm6fUq8f__"